// extracted by mini-css-extract-plugin
export var centerText = "_6z-8";
export var container = "_6z-0";
export var doughnutContainer = "_6z-7";
export var legend = "_6z-a";
export var legendItemColorDisplay = "_6z-b";
export var legendItemLabel = "_6z-d";
export var legendItemValue = "_6z-c";
export var lg = "_6z-5";
export var maxWidth = "_6z-9";
export var md = "_6z-4";
export var responsive = "_6z-6";
export var sm = "_6z-3";
export var xs = "_6z-2";
export var xxs = "_6z-1";